<template>
  <div :class="['parlays-zone', {'expandTop': headerMessageState && mobileBigAndBelow}]">
    <popular-parlays v-if="isPopularParlaysEnabled" :displayMode="'fullPage'" />
  </div>
</template>

<script>
import store from '@/store'
import config from '@/config'
import Screen from '@/components/mixins/Screen'
import PopularParlays from './PopularParlays.vue'

export default {
  name: 'ParlaysZone',
  components: { PopularParlays },
  mixins: [Screen],
  data () {
    return {
      isDisabledExpansionPanel: true
    }
  },
  computed: {
    isPopularParlaysEnabled () {
      return config.app.autoconf.PLAYER_PERSONALISATION.enablePopularParlays
    },
    headerMessageState () {
      return store.getters['overlayState/getHeaderMessageState']
    }
  },
  methods: {},
  mounted () {},
  watch: {}
}
</script>

<style lang="stylus">
@import "~@/css/config"

.parlays-zone
  min-height 30vh
  margin-right: 5px
  position: relative
  pointer-events: auto
  max-width: 810px
  margin: 0 auto
  background var(--popular-parlays-holder-bgr)
  &.expandTop
    .v-toolbar
      top 112px
  @media (min-width: 1024px) and (max-width: 1240px)
    max-width 490px
  @media (min-width: 1241px) and (max-width: 1365px)
    max-width 590px
  @media (min-width: 1366px) and (max-width: 1440px)
    max-width 700px
  @media mobile-big-and-below
    margin-right 0
    max-width none
  .empty-zone
    color var(--popular-parlays-content-color)
    display flex
    justify-content center
    align-items center
    font-size 26px
    height 30vh
    text-align center
  .v-toolbar
    padding: 5px !important
    position: fixed
    top: 110px
    z-index: 6
    width: 100%
    max-width: 810px
    left: 50%
    margin-left: -490px
    box-sizing: border-box
    background: var(--popular-parlays-content-bgr)
    color: var(--popular-parlays-content-color)
    /* Toolbar Tablet Resolution */
    @media (min-width: 1024px) and (max-width: 1240px)
      max-width 490px
      margin-left -304px
    @media (min-width: 1241px) and (max-width: 1365px)
      max-width 590px !important
      margin-left -353px !important
    @media (min-width: 1366px) and (max-width: 1380px)
      max-width 700px
      margin-left -408px
    @media (min-width: 1381px) and (max-width: 1395px)
      max-width 700px
      margin-left -407px
    @media (min-width: 1396px) and (max-width: 1440px)
      max-width 700px
      margin-left -403px
    @media (min-width: 1440px)
      margin-left -429px
    @media (min-width: 1441px)
      margin-left -490px
    @media mobile-big-and-below
      top 61px
      width 100%
      left 0
      margin-left 0
      max-width none
    @media mobile-small
      padding 2px !important
    .v-toolbar__content
      height 50px !important
      padding 0
      justify-content space-between
      display flex
      .reset-button
        background var(--popular-parlay-primary-btn-bgr)
        border-radius var(--popular-parlay-primary-btn-border-radius)
        color: var(--popular-parlay-primary-btn-color)
        border var(--popular-parlay-primary-btn-border)
        width: 50px
        height: 40px
        text-align: center
        align-self: center
        align-content: center
        cursor pointer
        font-size 14px
        @media mobile-small
          width auto
          padding 0 2px
      .toolbar-items
        display flex
        margin-left auto
        margin-right 5px
        @media mobile-big-and-below
          margin-left initial
          margin-right initial
      .v-toolbar__items
        display flex
        align-items center
        justify-content flex-start
        border 1px solid var(--popular-parlays-content-borders-color)
        border-radius 10px
        padding 5px
        min-width 50px
        margin-right 5px
        @media mobile-big-and-below
          padding 3px
        @media mobile-small
          padding 3px
          margin-right 3px
        .filter-buttons
          display flex
          flex-direction column
          .filter-button-title
            @media mobile-big-and-below
              line-height 1.1
            @media mobile-small
              font-size 11px
              line-height 1.1
          .filter-button-selected
            display flex
            align-items center
            color var(--popular-parlay-eventname-color)
            i
              font-size 16px
              color var(--popular-parlay-eventname-color)
              @media mobile-small
                font-size 11px
            span
              text-transform capitalize
              @media mobile-big-and-below
                white-space nowrap
                overflow hidden
                text-overflow ellipsis
                max-width 75px
              @media mobile-small
                font-size 11px
                line-height 11px
                max-width 65px
      .pp_header
        display flex
        align-items center
        justify-content space-between
        .header-title
          display flex
          align-items center
          //padding-left 15px
          @media mobile-big-and-below
            padding-left 0
          .pp_icon
            background var(--pp-icon) 100% center no-repeat
            width 27px
            height 17px
            display inline-flex
            margin-right 10px
            @media (max-width: 1440px)
              margin-right 5px
          .pp_title
            font-size 16px
            font-family 'Roboto Condensed Bold'
            @media tablet-and-below
              display none
  .popular_parlays_holder
    margin 0 !important
    padding-top 100px
    min-height 30vh
    @media mobile-big-and-below
      padding-top 150px
    .v-expansion-panel__header
      .filter-parlays
        .filter
          pointer-events: auto
          cursor pointer
    .v-expansion-panel__body
      padding 0 20px !important
      @media mobile-big-and-below
        padding 0 10px !important
      .recomended-parlays
        display flex
        min-height 25vh
        justify-content center
        align-items center
        flex-wrap wrap
        justify-content space-around
        overflow auto
        overflow-x hidden
        @media mobile-big-and-below
          width 100%
        .parlays-wrapper
          width 100%
        .popular-parlay
          .parlays-container
            margin-bottom 10px
            width 100%
            height auto
            margin-right 0
            @media mobile-big-and-below
              width 100%
            .parlay-header
              cursor auto
              .title-wrapper
                .title-wrapper-potential-return
                  font-size 16px
                .sgpplus-title-wrapper
                  cursor auto
                  .header-title
                    font-size 16px
                    line-height 18px
              .title-wrapper-potential-return
                .header-title
                  font-size 16px
                .potential-return
                  font-size 16px
              .number-of-selections
                font-size 12px
            .content-wrapper
              cursor auto
              .parlay-selection.parlay
                .leg-icon:after
                  height 55px
              .parlay-selection.SGP
                .leg-icon:after
                  height 34px
                .content-left
                  .selection-name
                    font-size 15px
                  .market-name
                    font-size 12px
              .parlay-selection
                .content
                  width 100%
                  .content-left
                    .selection-name
                      font-size 15px
                      line-height 18px
                    .market-name
                      font-size 12px
                      line-height 17px
                      @media mobile-big-and-below
                        max-width 195px
                    .event-name
                      font-size 13px
                      line-height 16px
                      @media mobile-big-and-below
                        max-width 195px
                  .content-right
                    .potential-return
                      font-size 15px
                    .start-date
                      font-size 12px
                      line-height 13px
                .content-left
                  .SGP
                    .sgp-title
                      .title-with-return
                        .event-name
                          width 85%
                          font-size 13px
                          line-height 15px
                        .potential-return
                          font-size 15px
                  .sgp-selection
                    .selection-data-wrapper
                      .potential-return
                        font-size 15px
                      .selection-data
                        .selection-name
                          font-size 15px
                          line-height 14px
                        .market-name
                          font-size 12px
                          line-height 15px
              .parlay-selection.parlay
                padding-left 15px
                .content
                  margin-left 10px
                .leg-icon:after
                  margin-left 5px
              .parlay-selection.parlay:last-child
                padding-bottom 10px
              .parlay-selection.SGP
                padding-left 15px
                .content-left
                  padding-left 10px
              .parlay-selection.SGP:last-child
                padding-bottom 10px
              .parlay-selection.parlay:nth-child(3)
                &:not(.less-then-4-legs)
                  padding-bottom 0
              .parlay-selection.SGPPlus:last-child
                padding-bottom 5px
              .parlay-selection.SGPPlus
                .content-left
                  .SGP
                    justify-content space-evenly
                    .sgp-title
                      .title-with-return.isSGP
                        width 100%
                    .leg-icon:after
                      margin-left 6px
                  .sgp-selection
                    justify-content space-evenly
                    .leg-icon:after
                      margin-left 6px
                  .sgp-selection:nth-child(4)
                    margin 0
                .content-left.has-more-than-2-legs
                  .sgp-selection
                    padding-bottom 0
          .add-to-betslip-wrapper
            .add-to-betslip-button
              button
                font-size 16px
                line-height 18px
              p
                font-size 12px
        .filter-empty
          font-size 26px
          text-align center
          @media mobile-big-and-below
            font-size 21px
.parlays-zone
  .loader
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 6
.v-menu__content
  position fixed
  .v-list.theme--light
    padding 0
    a
      height 40px
      padding 0 10px
      border-bottom 1px solid #F0F0F0
      @media mobile-big-and-below
        height auto
        padding 5px
        font-size 14px
        line-height 1.5
.generic
  .application
    .application--wrap
      .sports-page
        .main-column
          .page-layout
            .center-column
              .parlays-zone
                .v-toolbar
                  background var(--popular-parlays-content-bgr)
                  color #fff
                  @media (min-width: 1024px) and (max-width: 1240px)
                    max-width 490px
                    margin-left -310px
                  @media (min-width: 1241px) and (max-width: 1365px)
                    max-width 590px !important
                    margin-left -358px !important
                  @media (min-width: 1366px) and (max-width: 1395px)
                    max-width 700px
                    margin-left -412px
                  @media (min-width: 1396px) and (max-width: 1440px)
                    max-width 700px
                    margin-left -410px
                  @media (min-width: 1440px)
                    margin-left -434px
                  @media (min-width: 1441px)
                    margin-left -495px
                  @media mobile-big-and-below
                    margin-left 0
                    top 64px
@media (min-width: 1366px) and (max-width: 1440px)
  .url-parlayzone
    .application
      .page-layout
        .center-column
          max-width 100% !important
</style>



// WEBPACK FOOTER //
// src/components/sports/bettingoffer/popularParlays/ParlayZone.vue